var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"calc(90vh - 20px)"}},[(_vm.widthChange)?_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"noboder":"","frameborder":"no","src":_vm.frameUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }